<!-- HTML -->
<template>
  <div>

    <!-- Modal -->
    <div class="modal" id="modal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-title">
            <h1>
              Get 15% off at our Store!
            </h1>
            <h3>
              Receive exclusive news and Store offers for great Jugem's Cloud merch!
            </h3>
            <a href="https://jugemscloud.bandcamp.com/" target="_blank">
              <figure class="image">
                <img src="../../assets/img/store/store-teaser.jpg" alt="The Jugem's Cloud Store items">
              </figure>
            </a>
          </div>
          <button
            class="delete"
            aria-label="close"
            v-on:click="openCloseModal('close')"
          ></button>
        </header>
        <section class="modal-card-body">
          <a href="https://mailchi.mp/42d7c1d60927/15-off" target="_blank">
            <div class="modal-button">
              <h3 class="subtitle is-5">
                Subscribe
              </h3>
            </div>
          </a>
        </section>
      </div>
    </div>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {

  name: "Modal",

  methods: {

    //--- Function Open/Close Modal ---//
    //---------------------------------//
    openCloseModal ( command ) {

    	// Open Modal
    	if ( command === 'open') {

    		document.getElementById('modal').children[1].classList.add('modal-animate-in-top');
    		document.getElementById('modal').classList.add('is-active');

    	// Close Modal
    	} else {

    		document.getElementById('modal').classList.remove('is-active');

    	}

    },

    //--- Function Begin Modal Counter ---//
    //------------------------------------//
    modalCounter ( ) {

      setTimeout( () => {
        this.openCloseModal('open');
      }, 10000);

    }

  },

  mounted() {

    this.modalCounter();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

h1, h3 {
  font-family: astera;
  color: $green-tint-2;
}
p {
  font-family: astera;
}
a {
  color: $green-tint-2;
}
a:hover {
  color: $green-tint-1;
}

/* Modal */
.modal-card-head, .modal-card-foot {
	background-color: $green-shade-2;
  border-radius: 0;
  border-bottom: none;
}
.modal-card-body {
  background-color: inherit;
  padding: 1rem 0 0 0;
}
.modal-card-title {
  width: 88%;
	color: $white;
}
.modal-button {
  width: 50%;
  left: 6rem;
  bottom: 4rem;
  padding: 20px;
  background-color: $green;
}
.modal-button:hover {
  background-color: $green-shade-2;
}
.modal-button h3 {
  color: $white;
}
.modal-card-title h1 {
  color: $white;
  font-size: 2rem;
}
img {
  padding-right: 1rem;
}
/* Modal Fade In Top */
.modal-animate-in-top {
	position: relative;
	animation: animateintop 0.4s
}
@keyframes animateintop {
	from {
		top: -300px;
		opacity:0
	} to {
		top: 0;
		opacity: 1
	}
}

@media screen and (max-width: 512px) {
  .title-box, .join-image, .join-button {
    left: 2rem;
  }
}

</style>
